export default "__VITE_ASSET__D6oY0GXT__"